import { Injectable } from '@angular/core';
import { combineLatest, Subject } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';

import { SitemateRecordStatuses, SitemateTaskTypes } from '@site-mate/dashpivot-shared-library';

import { ISitemateTaskDefinitionWeb } from 'app/shared/model/task-definition.model';
import { ErrorHandler } from 'app/shared/service/error-handler.service';
import { RouteParamsService } from 'app/shared/service/route-params.service';
import { TaskService } from 'app/shared/service/task.service';

@Injectable({
  providedIn: 'root',
})
export class TemplateLinksTeamService {
  private readonly destroy$ = new Subject<void>();
  constructor(
    private readonly errorHandler: ErrorHandler,
    private readonly routeParamsService: RouteParamsService,
    private readonly taskService: TaskService,
  ) {}

  public retrieveLinks(teamId): void {
    const active$ = this.taskService.getTemplateLinks(teamId, SitemateRecordStatuses.Open);
    const archived$ = this.taskService.getTemplateLinks(teamId, SitemateRecordStatuses.Archived);

    combineLatest([active$, archived$])
      .pipe(takeUntil(this.destroy$), catchError(this.errorHandler.handle.bind(this.errorHandler)))
      .subscribe(([active, archived]) => {
        const activeLinks = active.map((link) => ({ ...link, status: SitemateRecordStatuses.Open }));
        const archivedLinks = archived.map((link) => ({ ...link, status: SitemateRecordStatuses.Archived }));
        const links: ISitemateTaskDefinitionWeb[] = [...activeLinks, ...archivedLinks];
        const singleLinks = links.filter((link) => link.taskType === SitemateTaskTypes.FormSingle);
        const recurringLinks = links.filter((link) => link.taskType === SitemateTaskTypes.FormRecurring);
        this.routeParamsService.set(SitemateTaskTypes.FormSingle, singleLinks);
        this.routeParamsService.set(SitemateTaskTypes.FormRecurring, recurringLinks);
      });
  }

  ngOnDestroy(): void {
    this.routeParamsService.set(SitemateTaskTypes.FormSingle, null);
    this.routeParamsService.set(SitemateTaskTypes.FormRecurring, null);
    this.destroy$.next();
    this.destroy$.complete();
  }
}
